/**
 * Orden de visualización del selector: lunes primero (convención ES).
 * Los valores son los índices de `Date.getDay()` (0=Dom … 6=Sáb), que es la
 * misma numeración con la que se persiste `preferences.studyDays` y la que usa
 * el backend para decidir si toca recordatorio hoy.
 */
export const WEEK_DAYS_ORDER = [1, 2, 3, 4, 5, 6, 0] as const;

export type WeekDay = (typeof WEEK_DAYS_ORDER)[number];

export interface StudyDaysSelectorHandle {
  /** Días seleccionados (índices `Date.getDay()`), ordenados de lunes a domingo. */
  getSelected: () => number[];
  /** True cuando hay al menos un día seleccionado. */
  isValid: () => boolean;
}

export interface StudyDaysSelectorProps {
  /**
   * Modo NO controlado (onboarding): días preseleccionados (índices
   * `Date.getDay()`). Si no se pasa, se preselecciona el día de la semana
   * actual (igual que la hora del slide siguiente toma la hora actual).
   */
  defaultDays?: number[];
  /**
   * Modo controlado (ajustes): si se pasa, la selección la gobierna el padre.
   * En este modo se ignora `defaultDays` y cada toggle emite `onChange`.
   */
  value?: number[];
  /** Cambios de selección (en ambos modos). Días ordenados de lunes a domingo. */
  onChange?: (days: number[]) => void;
  /** Deshabilita interacciones — típicamente mientras el padre guarda. */
  disabled?: boolean;
  /** Oculta el texto de ayuda interno (p. ej. en Ajustes, donde el item ya tiene su propia descripción). */
  hideHelper?: boolean;
  /** Notifica cuando la validez (≥1 día) cambia. */
  onValidityChange?: (isValid: boolean) => void;
}
